<template>
  <v-layout wrap class="container px-2 py-0">
    <router-view />
  </v-layout>
</template>

<script>
import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  name: 'DriversPage',
  beforeRouteEnter(to, from, next) {
    checkRouteAccess('driver_view', next);
  },
};
</script>

<style lang="scss" scoped></style>
